!(function () {
  "use strict";
  customElements.get("parallax-hero") ||
    customElements.define(
      "parallax-hero",
      class extends HTMLElement {
        defaultOptions = { center: !0, round: !0, frame: this };
        constructor() {
          (super(),
            (this.rellax = null),
            (this.refreshEvent = window.theme.debounce(() => {
              this.refresh();
            }, 500)));
        }
        connectedCallback() {
          const e = this.querySelector("[data-parallax-img]");
          if (!e) return;

          const isMobile = window.matchMedia("(max-width: 749px)").matches;
          const desktopSpeed = this.getAttribute("data-parallax-speed") || -2;
          const mobileSpeed = this.getAttribute("data-parallax-speed-mobile") || -1;

          const speed = parseFloat(isMobile ? mobileSpeed : desktopSpeed);

          const r = { ...this.defaultOptions, speed },
            s = window.themeRellax?.Rellax || window.Rellax;

          ((this.rellax = new s(e, r)),
            document.addEventListener("theme:resize", this.refreshEvent));

          const n = () => requestAnimationFrame(() => this.refresh());

          "complete" === document.readyState
            ? n()
            : window.addEventListener("load", n, { once: !0 });
        }
        refresh() {
          this.rellax?.refresh();
        }
        disconnectedCallback() {
          (this.rellax?.destroy(),
            document.removeEventListener("theme:resize", this.refreshEvent));
        }
      },
    );
})();
